// @flow

import { List, Map, fromJS } from 'immutable';

export const GET_LISTS = 'App/home/GET_LISTS';
export const GET_LISTS_SUCCESS = 'App/home/GET_LISTS_SUCCESS';
export const GET_LISTS_FAIL = 'App/home/GET_LISTS_FAIL';
export const CLEAR_LISTS = 'App/home/CLEAR_LISTS';

const initialState = Map({
  getListsLoading: false,
  listsData: List([]),
  getListsFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_LISTS:
      return state.merge({
        getListsLoading: true,
        getListsFail: null,
      });
    case GET_LISTS_SUCCESS:
      return state.merge({
        getListsLoading: false,
        listsData: fromJS(action.data),
        getListsFail: null,
      });
    case GET_LISTS_FAIL:
      return state.merge({
        getListsLoading: false,
        getListsFail: fromJS(action.data),
      });
    case CLEAR_LISTS:
      return state.set('listsData', List([]));
    default:
      return state;
  }
};

export const getLists = (data : any) => (dispatch : any) => dispatch({ type: GET_LISTS, data });

export const clearLists : any = () => ({ type: CLEAR_LISTS });
